module.exports = __webpack_public_path__ + "img/goods6.dbd42dd3.jpg";